import * as type from '../mutation-type'
import * as taskApi from '../../api/task.js'
import * as smsApi from '../../api/sms.js'

const moment = require('moment')

const state = {
  borrowerInfo: {},
  taskInfo: {},
  currentLoanItem: {},
  loanItemInfoList: [{}],
  contactsInfo: [],
  userContactsInfo: [],
  userCallsInfo: [],
  collectionLogs: [],
  mertCaseList: [],
  caseSionList: [],
  smsTemplates: [],
  userAddress: [],
  collectionLogsTotal: 0,
  mertCaseListTotal: 0,
  caseSionListTotal: 0,
  contactsInfoLoans: [],
  reportList: [],
  taskLabel: [],
  userSMSRecord: [],
  SMSlog: [],
  SMSlogTotal: 0,
  totalRepayAmount: 0
}

const getters = {
  borrowerInfo: state => state.borrowerInfo,
  taskInfo: state => state.taskInfo,
  currentLoanItem: state => state.currentLoanItem,
  loanItemInfoList: state => state.loanItemInfoList,
  contactsInfo: state => state.contactsInfo,
  userContactsInfo: state => state.userContactsInfo,
  userCallsInfo: state => state.userCallsInfo,
  collectionLogs: state => state.collectionLogs,
  mertCaseList: state => state.mertCaseList,
  caseSionList: state => state.caseSionList,
  smsTemplates: state => state.smsTemplates,
  userAddress: state => state.userAddress,
  collectionLogsTotal: state => state.collectionLogsTotal,
  mertCaseListTotal: state => state.mertCaseListTotal,
  caseSionListTotal: state => state.caseSionListTotal,
  contactsInfoLoans: state => state.contactsInfoLoans,
  reportList: state => state.reportList,
  taskLabel: state => state.taskLabel,
  userSMSRecord: state => state.userSMSRecord,
  SMSlog: state => state.SMSlog,
  SMSlogTotal: state => state.SMSlogTotal,
  totalRepayAmount: state => state.totalRepayAmount
}

const actions = {
  fetchBorrowerInfo({
    commit
  }, {
    taskId
  }) {
    taskApi.fetchBorrowerInfo(taskId).then(res => {
      commit(type.SET_BORROWER_INFO, res.data)
    })
  },
  fetchTaskInfo({
    commit
  }, {
    taskId
  }) {
    return taskApi.fetchTaskInfo(taskId).then(res => {
      commit(type.SET_TASK_INFO, res.data)
    })
  },
  setCurrentLoanItem({
    commit
  }, {
    loanItem
  }) {
    commit(type.SET_CURRENT_LOAN_ITEM, loanItem)
  },
  async fetchLoanItemInfo({
    commit
  }, {
    taskId
  }) {
    const res = await taskApi.fetchLoanItemInfo(taskId)
    res.data.map((item, index) => {
      item.totalPrincipal = Number(item.totalPrincipal).toFixed(2)
      item.totalInterest = Number(item.totalInterest).toFixed(2)
      item.totalFee = Number(item.totalFee).toFixed(2)
      item.overdueManageFee = Number(item.overdueManageFee).toFixed(2)
      item.totalRepayAmount = Number(item.totalRepayAmount).toFixed(2)
      item.orderAmount = item.orderAmount.toFixed(2)
    })
    commit(type.SET_ITEM_INFO, [...res.data])
    return [...res.data]
  },
  fetchContactsInfo({
    commit
  }, {
    taskId
  }) {
    taskApi.fetchContactsInfo(taskId).then(res => {
      commit(type.SET_CONTACTS_INFO, res.data)
      // commit(type.SET_CONTACTS_INFO_LOANS, res.data.loans)
    })
  },
  fetchUserContactsInfo({
    commit
  }, {
    taskId
  }) {
    taskApi.fetchUserContactsInfo(taskId).then(res => {
      commit(type.SET_USER_CONTACTS_INFO, res.data)
    })
  },
  fetchUserAddress({
    commit
  }, {
    taskId
  }) {
    taskApi.fetchUserAddress(taskId).then(res => {
      commit(type.SET_USER_ADDRESS, res.data)
    })
  },
  fetchUserSMSRecord({
    commit
  }, {
    taskId
  }) {
    taskApi.fetchUserSMSRecord(taskId).then(res => {
      res.data.sort(function(a, b) {
        if (a.count < b.count) {
          return 1
        }
        if (a.count > b.count) {
          return -1
        }
        return 0
      })
      commit(type.SET_USER_SMSRECORD, res.data)
    })
  },
  getTaskLabel({
    commit
  }, {
    taskId
  }) {
    taskApi.getTaskLabel(taskId).then(res => {
      commit(type.SET_TASK_LABEL, res.data)
    })
  },
  fetchReportList({
    commit
  }, {
    taskId,
    page,
    size
  }) {
    taskApi.fetchReportList(taskId, page, size).then(res => {
      res.data.records.map(item => {
        item.createDate = moment(item.createDate).format('YYYY-MM-DD HH:mm:ss')
      })
      commit(type.SET_REPORTLIST, res.data.records)
    })
  },
  fetchUserCallsInfo({
    commit
  }, {
    taskId
  }) {
    taskApi.fetchUserCallsInfo(taskId).then(res => {
      commit(type.SET_USER_CALLS_INFO, res.data)
    })
  },
  recordCollectionLog({
    commit
  }, {
    params
  }) {
    taskApi.recordCollectionLog(params).then(res => {})
  },
  fetchCollectionLogs({
    commit
  }, {
    contractNumber,
    page,
    size,
    userId
  }) {
    taskApi.fetchCollectionLogs(contractNumber, page, size, userId).then(res => {
      // res.data.records.map(item => {
      //   item.createdAt = moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')
      // })
      commit(type.SET_COLLECTION_LOGS, res.data.records)
      commit(type.SET_COLLECTION_LOGS_TOTAL, res.data.total)
    })
  },
  queryMertCaseList({
    commit
  }, {
    contractNumber,
    page,
    size
  }) {
    taskApi.queryMertCaseList(contractNumber, page, size).then(res => {
      commit(type.SET_MERT_CASE_LIST, res.data.records)
      commit(type.SET_MERT_CASE_LIST_TOTAL, res.data.total)
    })
  },
  queryCaseSionList({
    commit
  }, {
    casePkid,
    contractNumber,
    page,
    size
  }) {
    taskApi.queryCaseSionList(casePkid, contractNumber, page, size).then(res => {
      commit(type.SET_CASE_SION_LIST, res.data.records)
      commit(type.SET_CASE_SION_LIST_TOTAL, res.data.total)
    })
  },
  getCollectionLog({
    commit
  }, {
    taskId,
    page,
    size
  }) {
    taskApi.getCollectionLog(taskId, page, size).then(res => {
      res.data.records.map(item => {
        item.createdAt = moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')
      })
      commit(type.SET_SMS_LOGS, res.data.records)
      commit(type.SET_SMS_LOGS_TOTAL, res.data.total)
    })
  },
  fetchSmsTemplates({
    commit
  }) {
    smsApi.fetchSmsTemplates().then(res => {
      commit(type.SET_SMS_TEMPLATES, res.data)
    })
  },
  sendSMS({
    commit
  }, {
    params
  }) {
    return smsApi.sendSMS(params).then(res => {
      return res.data
    })
  },
  deduct({
    commit
  }, {
    params
  }) {
    return taskApi.deduct(params).then(res => {
      return res
    })
  }
}

const mutations = {
  [type.TOTAL_REPAY_AMOUNT](state, info) {
    state.totalRepayAmount = info
  },
  [type.SET_TASK_INFO](state, info) {
    state.taskInfo = info
  },
  [type.SET_CURRENT_LOAN_ITEM](state, info) {
    state.currentLoanItem = info
  },
  [type.SET_BORROWER_INFO](state, info) {
    state.borrowerInfo = info
  },
  [type.SET_ITEM_INFO](state, info) {
    state.loanItemInfoList = info
  },
  [type.SET_CONTACTS_INFO](state, info) {
    state.contactsInfo = info
  },
  [type.SET_SMS_LOGS](state, info) {
    state.SMSlog = info
  },
  [type.SET_SMS_LOGS_TOTAL](state, info) {
    state.SMSlogTotal = info
  },
  [type.SET_CONTACTS_INFO_LOANS](state, info) {
    state.contactsInfoLoans = info
  },
  [type.SET_USER_CONTACTS_INFO](state, info) {
    state.userContactsInfo = info
  },
  [type.SET_USER_ADDRESS](state, info) {
    state.userAddress = info
  },
  [type.SET_USER_SMSRECORD](state, info) {
    state.userSMSRecord = info
  },
  [type.SET_REPORTLIST](state, info) {
    state.reportList = info
  },
  [type.SET_TASK_LABEL](state, info) {
    state.taskLabel = info
  },
  [type.SET_USER_CALLS_INFO](state, info) {
    state.userCallsInfo = info
  },
  [type.SET_COLLECTION_LOGS](state, info) {
    state.collectionLogs = info
  },
  [type.SET_COLLECTION_LOGS_TOTAL](state, info) {
    state.collectionLogsTotal = info
  },
  [type.SET_MERT_CASE_LIST](state, info) {
    state.mertCaseList = info
  },
  [type.SET_MERT_CASE_LIST_TOTAL](state, info) {
    state.mertCaseListTotal = info
  },
  [type.SET_CASE_SION_LIST](state, info) {
    state.caseSionList = info
  },
  [type.SET_CASE_SION_LIST_TOTAL](state, info) {
    state.caseSionListTotal = info
  },
  [type.SET_SMS_TEMPLATES](state, info) {
    state.smsTemplates = info
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
